export default __webpack_public_path__ + "static/media/trade_hk_06.ef3107ee.png";